




import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class FastLogin extends Vue {
  private module: "" | "gailan" | "shujuku" | "wajue" | "moxing" | string = "";
  private loginname: any = "";
  private password: any = "";
  private login() {
    if (!this.module || !this.loginname || !this.password) {
      this.$message.error("验证失败，请正常登录或重试");
      this.$router.push("/access/login");
      return;
    }
    const params: any = {
      手机号: this.loginname,
      密码: this.password
    };
    axios.post("api/user/login", params).then(({ data }) => {
      localStorage.setItem("token", data.data.token);
      resHandle(this, data).then(() => {
        switch (this.module) {
          case "gailan":
            this.$router.push("/main/home");
            break;
          case "shujuku":
            this.$router.push("/main/project/project-list");
            break;
          case "wajue":
            this.$router.push("/main/dig/tongue-quality");
            break;
          case "moxing":
            this.$router.push("/main/model/my-model");
            break;
        }
      });
    });
  }
  // 18801611056
  // li18801611056
  // shujuku
  // wajue
  // moxing
  private mounted() {
    this.module = this.$route.params.module;
    this.loginname = this.$route.params.loginname;
    this.password = this.$route.params.password;
    this.login();
  }
}
